import React, { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    Datagrid,
    EditButton,
    BooleanField,
    FilterButton,
    ReferenceField,
    SearchInput,
    TextInput
} from 'react-admin';

const ListFilters: JSX.Element[] = [
    <SearchInput source="name" alwaysOn />,
    <TextInput label="Email" source="email"  />,
];


const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* A child of HQ_Data::email_finder in the tree, so anyone granted the finder keeps
                this button; it exists so the results can be withheld on their own. */}
                <CreateButton />
            <FilterButton />
        </TopToolbar>
    );
}


export const EmailFinderResultsList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions/> }
            filters={ ListFilters }
        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="name"  />
                <TextField source="email" />
                <ReferenceField source="emailFinder" reference="email_finders"  />
                <ReferenceField source="adminUser" reference="admin_users"  />
                <EditButton />
            </Datagrid>
        </List>
    );
}
